import useScrollAnimation from '../../../hooks/useScrollAnimation';

const features = [
  {
    icon: 'ri-eye-line',
    title: 'Visual y Predictivo',
    desc: 'Mira tus niveles de stock de un vistazo con indicadores de color. Verde, amarillo, rojo — sin interpretaciones.',
    tag: 'Verde = OK  •  Rojo = Urgente',
    img: 'https://readdy.ai/api/search-image?query=clean%20inventory%20dashboard%20showing%20colored%20stock%20level%20progress%20bars%20green%20yellow%20red%20status%20indicators%20product%20list%20minimal%20white%20UI%20modern%20app%20interface&width=420&height=260&seq=stock003&orientation=landscape',
    accent: 'emerald',
    delay: 'anim-fade-up-1',
  },
  {
    icon: 'ri-notification-3-line',
    title: 'Alertas de Escasez',
    desc: 'Recibe avisos automáticos cuando un producto esté por agotarse. No vuelvas a decir "no hay".',
    tag: 'Notificación instantánea',
    img: 'https://readdy.ai/api/search-image?query=smartphone%20mobile%20notification%20alert%20low%20stock%20inventory%20warning%20clean%20minimal%20white%20background%20business%20app%20push%20notification%20modern%20design&width=420&height=260&seq=stock004&orientation=landscape',
    accent: 'red',
    delay: 'anim-fade-up-2',
  },
  {
    icon: 'ri-history-line',
    title: 'Historial de Movimientos',
    desc: 'Quién movió qué y cuándo. Transparencia total y control absoluto sobre cada cambio en tu inventario.',
    tag: 'Trazabilidad completa',
    img: 'https://readdy.ai/api/search-image?query=activity%20timeline%20log%20history%20movements%20records%20clean%20modern%20app%20interface%20list%20view%20minimal%20white%20chronological%20business%20events%20tracking&width=420&height=260&seq=stock005&orientation=landscape',
    accent: 'amber',
    delay: 'anim-fade-up-3',
  },
  {
    icon: 'ri-trophy-line',
    title: 'Reportes de Best Sellers',
    desc: 'Descubre qué productos son los que realmente llenan tu caja registradora. Toma decisiones basadas en datos reales.',
    tag: 'Top 10 productos del mes',
    img: 'https://readdy.ai/api/search-image?query=best%20sellers%20product%20ranking%20bar%20chart%20analytics%20dashboard%20top%20products%20performance%20data%20visualization%20colorful%20minimal%20professional%20business%20report&width=420&height=260&seq=stock006&orientation=landscape',
    accent: 'emerald',
    delay: 'anim-fade-up-4',
  },
];

const accentMap: Record<string, { bg: string; text: string; tagBg: string; tagText: string }> = {
  emerald: { bg: 'bg-emerald-100', text: 'text-emerald-600', tagBg: 'bg-emerald-50', tagText: 'text-emerald-700' },
  red: { bg: 'bg-red-100', text: 'text-red-500', tagBg: 'bg-red-50', tagText: 'text-red-600' },
  amber: { bg: 'bg-amber-100', text: 'text-amber-600', tagBg: 'bg-amber-50', tagText: 'text-amber-700' },
};

const SolucionSection = () => {
  const { ref, visible } = useScrollAnimation();

  return (
    <section id="solucion" className="py-16 sm:py-24 bg-gray-50/60">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div ref={ref} className={`text-center mb-10 sm:mb-16 ${visible ? 'anim-fade-up' : 'scroll-hidden'}`}>
          <span className="inline-block bg-emerald-50 text-emerald-600 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            La Solución
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-5xl font-black text-gray-900 leading-tight mb-4" style={{ fontFamily: "'Syne', sans-serif" }}>
            StockSimple: El <span className="text-emerald-600">reemplazo definitivo</span>
            <br className="hidden sm:block" /> al papel y lápiz.
          </h2>
          <p className="text-gray-500 text-base sm:text-lg max-w-xl mx-auto">
            Cuatro funciones pensadas para dueños de tiendas, no para programadores.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {features.map((f) => {
            const a = accentMap[f.accent];
            return (
              <div
                key={f.title}
                className={`bg-white rounded-2xl border border-gray-100 overflow-hidden hover:scale-[1.02] transition-transform ${visible ? f.delay : 'scroll-hidden'}`}
              >
                <div className="h-40 sm:h-44 overflow-hidden">
                  <img
                    src={f.img}
                    alt={f.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-5 sm:p-6">
                  <div className={`w-10 h-10 flex items-center justify-center ${a.bg} rounded-lg mb-4`}>
                    <i className={`${f.icon} text-xl ${a.text}`} />
                  </div>
                  <h3 className="text-base font-bold text-gray-900 mb-2">{f.title}</h3>
                  <p className="text-sm text-gray-500 leading-relaxed mb-4">{f.desc}</p>
                  <span className={`inline-block text-xs font-semibold ${a.tagBg} ${a.tagText} px-3 py-1 rounded-full`}>
                    {f.tag}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SolucionSection;
